import React from 'react';

const TestDisplayComponent = ({ selectedTest, deletethis, actscores }) => {

  // ── AP Calculus AB ─────────────────────────────────────────────
  if (selectedTest?.type === 'AP_Calc_AB') {
    const parsed = JSON.parse(selectedTest.eng_score);
    const mcqScore = parsed.mcq;
    const frqScore = parsed.frq;

    const mcqLabel = mcqScore >= 35 ? 'Excellent' : mcqScore >= 25 ? 'Above Avg' : mcqScore >= 18 ? 'Average' : mcqScore >= 10 ? 'Below Avg' : 'Needs Work';
    const frqLabel = frqScore >= 5 ? 'Excellent' : frqScore >= 4 ? 'Above Avg' : frqScore >= 3 ? 'Average' : frqScore >= 1 ? 'Below Avg' : 'Needs Work';

    return (
      <div className="pb-4 pr-10">
        <div className="mb-4">
          <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-widest mb-1">AP Calculus AB</p>
          <h2
            className="text-lg font-bold text-slate-800 cursor-pointer hover:text-blue-600 transition-colors"
            onClick={() => window.open(`/dashboard/results/sat/quiz/${selectedTest.test_id}`, '_blank')}
          >
            {selectedTest.test_name}
          </h2>
          <p className="text-xs text-slate-400 mt-0.5">{selectedTest.date.split('T')[0]}</p>
        </div>

        {/* AP Score focal */}
        <div className="bg-slate-50 border border-slate-200 p-5 mb-4 flex flex-col items-center">
          <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-widest mb-2">AP Score</p>
          <div className="flex items-baseline gap-1">
            <span className="text-5xl font-black text-blue-600">{parsed.APscore || '—'}</span>
            <span className="text-xl text-slate-400">/ 5</span>
          </div>
        </div>

        {/* MCQ + FRQ */}
        <div className="grid grid-cols-2 gap-3 mb-4">
          <div className="bg-slate-50 border border-slate-200 p-4">
            <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-widest mb-2">Multiple Choice</p>
            <div className="flex items-baseline gap-1 mb-1">
              <span className="text-3xl font-bold text-slate-800">{mcqScore !== undefined ? Math.round(mcqScore) : '—'}</span>
              <span className="text-sm text-slate-400">/ 45</span>
            </div>
            <p className="text-xs font-medium text-slate-500">{mcqLabel}</p>
          </div>
          <div className="bg-slate-50 border border-slate-200 p-4">
            <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-widest mb-2">Free Response</p>
            <div className="flex items-baseline gap-1 mb-1">
              <span className="text-3xl font-bold text-slate-800">{frqScore !== undefined ? Math.round(frqScore) : '—'}</span>
              <span className="text-sm text-slate-400">/ 6</span>
            </div>
            <p className="text-xs font-medium text-slate-500">{frqLabel}</p>
          </div>
        </div>

        <div className="flex gap-2">
          <button
            className="flex-1 py-2 text-xs font-medium text-slate-600 bg-slate-100 hover:bg-slate-200 transition-colors"
            onClick={() => window.open(`/dashboard/results/sat/quiz/${selectedTest.test_id}`, '_blank')}
          >
            View Details
          </button>
          <button
            className="py-2 px-4 text-xs font-medium text-slate-500 bg-slate-100 hover:bg-slate-200 transition-colors"
            onClick={() => deletethis()}
          >
            Delete
          </button>
        </div>
      </div>
    );
  }

  // ── ACT ────────────────────────────────────────────────────────
  if (selectedTest?.type === 'ACT') {
    const composite = Math.round((actscores.english + actscores.math + actscores.reading + actscores.science) / 4);

    return (
      <div className="pb-4 pr-10">
        <div className="mb-4">
          <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-widest mb-1">Digital ACT</p>
          <h2
            className="text-lg font-bold text-slate-800 cursor-pointer hover:text-blue-600 transition-colors"
            onClick={() => window.open(`/dashboard/results/sat/quiz/${selectedTest.test_id}`, '_blank')}
          >
            {selectedTest.test_name}
          </h2>
          <p className="text-xs text-slate-400 mt-0.5">{selectedTest.date.split('T')[0]}</p>
        </div>

        {/* Composite */}
        <div className="bg-slate-50 border border-slate-200 p-4 mb-4 flex items-center justify-between">
          <div>
            <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-widest mb-1">Composite</p>
            <div className="flex items-baseline gap-1">
              <span className="text-4xl font-black text-slate-800">{composite}</span>
              <span className="text-lg text-slate-400">/ 36</span>
            </div>
          </div>
          <div className="w-14 h-14 rounded-full bg-blue-600 flex items-center justify-center shrink-0">
            <span className="text-white text-xl font-black">{composite}</span>
          </div>
        </div>

        {/* Section scores */}
        <div className="grid grid-cols-2 gap-2.5 mb-4">
          {[
            { label: 'English',  score: actscores.english,  color: 'border-l-purple-400' },
            { label: 'Math',     score: actscores.math,     color: 'border-l-blue-400' },
            { label: 'Reading',  score: actscores.reading,  color: 'border-l-slate-400' },
            { label: 'Science',  score: actscores.science,  color: 'border-l-indigo-400' },
          ].map(({ label, score, color }) => (
            <div key={label} className={`bg-slate-50 border border-slate-200 border-l-4 ${color} p-3`}>
              <p className="text-[10px] font-medium text-slate-400 mb-1">{label}</p>
              <div className="flex items-baseline gap-0.5">
                <span className="text-2xl font-bold text-slate-800">{score}</span>
                <span className="text-xs text-slate-400">/ 36</span>
              </div>
            </div>
          ))}
        </div>

        <div className="flex gap-2">
          <button
            className="flex-1 py-2 text-xs font-medium text-slate-600 bg-slate-100 hover:bg-slate-200 transition-colors"
            onClick={() => window.open(`/dashboard/results/sat/quiz/${selectedTest.test_id}`, '_blank')}
          >
            View Details
          </button>
          <button
            className="py-2 px-4 text-xs font-medium text-slate-500 bg-slate-100 hover:bg-slate-200 transition-colors"
            onClick={() => deletethis()}
          >
            Delete
          </button>
        </div>
      </div>
    );
  }

  // ── Default: Digital SAT ────────────────────────────────────────
  const engScore  = parseInt(selectedTest.eng_score)  || 0;
  const mathScore = parseInt(selectedTest.math_score) || 0;
  const totalScore = engScore + mathScore;
  const totalPct = Math.min((totalScore / 1600) * 100, 100);
  const engPct   = Math.min((engScore  / 800) * 100, 100);
  const mathPct  = Math.min((mathScore / 800) * 100, 100);

  const getLabel = (score, max) => {
    const p = score / max;
    if (p > 0.875) return 'Excellent';
    if (p > 0.75)  return 'Above Avg';
    if (p > 0.625) return 'Average';
    return 'Needs Work';
  };

  return (
    <div className="pb-4 pr-10">
      {/* Header */}
      <div className="mb-5">
        <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-widest mb-1">Digital SAT</p>
        <h2
          className="text-lg font-bold text-slate-800 cursor-pointer hover:text-blue-600 transition-colors leading-snug mb-0.5"
          onClick={() => window.open(`/dashboard/results/sat/quiz/${selectedTest.test_id}`, '_blank')}
        >
          {selectedTest.test_name}
        </h2>
        <p className="text-xs text-slate-400">{selectedTest.date.split('T')[0]}</p>
      </div>

      {/* Total Score */}
      <div className="bg-slate-50 border border-slate-200 p-5 mb-3 flex flex-col items-center">
        <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-widest mb-2">Total Score</p>
        <div className="flex items-baseline gap-1.5 mb-3">
          <span className="text-5xl font-black text-slate-900 tabular-nums">{totalScore || '—'}</span>
          <span className="text-lg text-slate-400">/ 1600</span>
        </div>
        <div className="w-full h-1.5 bg-slate-200 overflow-hidden mb-1.5">
          <div
            className="h-full bg-blue-500 transition-all duration-700"
            style={{ width: `${totalPct}%` }}
          />
        </div>
        <div className="flex justify-between w-full">
          <span className="text-[10px] text-slate-400">Overall</span>
          <span className="text-[10px] font-semibold text-blue-600">{Math.round(totalPct)}%</span>
        </div>
      </div>

      {/* Section Cards */}
      <div className="grid grid-cols-2 gap-2.5 mb-5">
        {/* Reading & Writing */}
        <div className="bg-slate-50 border border-slate-200 border-l-4 border-l-blue-400 p-4">
          <p className="text-[9px] font-semibold text-slate-400 uppercase tracking-widest mb-2">Reading & Writing</p>
          <div className="flex items-baseline gap-1 mb-2">
            <span className="text-3xl font-black text-slate-800 tabular-nums">{engScore || '—'}</span>
            <span className="text-sm text-slate-400">/ 800</span>
          </div>
          <div className="h-1 bg-slate-200 overflow-hidden mb-1">
            <div className="h-full bg-blue-400 transition-all duration-700" style={{ width: `${engPct}%` }} />
          </div>
          <div className="flex justify-between">
            <span className="text-[9px] text-slate-400">{getLabel(engScore, 800)}</span>
            <span className="text-[9px] font-semibold text-blue-500">{Math.round(engPct)}%</span>
          </div>
        </div>

        {/* Math */}
        <div className="bg-slate-50 border border-slate-200 border-l-4 border-l-violet-400 p-4">
          <p className="text-[9px] font-semibold text-slate-400 uppercase tracking-widest mb-2">Math</p>
          <div className="flex items-baseline gap-1 mb-2">
            <span className="text-3xl font-black text-slate-800 tabular-nums">{mathScore || '—'}</span>
            <span className="text-sm text-slate-400">/ 800</span>
          </div>
          <div className="h-1 bg-slate-200 overflow-hidden mb-1">
            <div className="h-full bg-violet-400 transition-all duration-700" style={{ width: `${mathPct}%` }} />
          </div>
          <div className="flex justify-between">
            <span className="text-[9px] text-slate-400">{getLabel(mathScore, 800)}</span>
            <span className="text-[9px] font-semibold text-violet-500">{Math.round(mathPct)}%</span>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="flex gap-2">
        <button
          className="flex-1 py-2.5 text-xs font-medium text-slate-600 bg-slate-100 hover:bg-slate-200 transition-colors"
          onClick={() => window.open(`/dashboard/results/sat/quiz/${selectedTest.test_id}`, '_blank')}
        >
          View Details
        </button>
        <button
          className="py-2.5 px-4 text-xs font-medium text-slate-500 bg-slate-100 hover:bg-slate-200 transition-colors"
          onClick={() => deletethis()}
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default TestDisplayComponent;
